const IDB_Enums = {
    resultCode : {
        "success" : 200,
        "notfound" : 404,
        "error" : 500
    }
}

export default IDB_Enums;